import React from 'react';

type WhitespaceProps = {
  width: number | string,
};

const Whitespace: React.FC<WhitespaceProps> = ({ width }) => {
  return <div style={{ width, flexShrink: 0 }}></div>
};

export default Whitespace;
